export default __webpack_public_path__ + "static/media/previewBackgroundIcon.bb243d45.png";